import { easeOut } from 'framer-motion'

export const StepStatus = {
	INCOMPLETE: 'incomplete',
	ACTIVE: 'active',
	COMPLETE: 'complete',
} as const

export type StepStatusType = (typeof StepStatus)[keyof typeof StepStatus]

export const badgeVariants = {
	incomplete: {
		backgroundColor: 'transparent',
		borderColor: '#d1d5db', // default-300
		color: '#6b7280', // default-500
		transition: { duration: 0.2, ease: easeOut },
	},
	active: {
		backgroundColor: 'transparent',
		borderColor: '#f5a524', // warning-500
		color: '#f5a524', // warning-500
		transition: { duration: 0.2, ease: easeOut },
	},
	complete: {
		backgroundColor: 'var(--leangap-green)',
		borderColor: 'var(--leangap-green)',
		color: '#11181c',
		boxShadow: '0 2px 8px 0 rgba(23,201,100,0.15)',
		transition: { duration: 0.2, ease: easeOut },
	},
}
